import * as React from 'react';
import { clsx } from 'clsx';
import Progress from './Progress';
export default function Looper(props) {
    const { prefixCls, percent = 0, className, style } = props;
    const dotClassName = `${prefixCls}-dot`;
    const holderClassName = `${dotClassName}-holder`;
    const hideClassName = `${holderClassName}-hidden`;
    // ===================== Render =====================
    return (React.createElement(React.Fragment, null,
        React.createElement("span", { className: clsx(holderClassName, className, percent > 0 && hideClassName), style: style },
            React.createElement("span", { className: clsx(dotClassName, `${prefixCls}-dot-spin`) }, [1, 2, 3, 4].map((i) => (React.createElement("i", { className: `${prefixCls}-dot-item`, key: i }))))),
        React.createElement(Progress, { prefixCls: prefixCls, percent: percent })));
}
